import SearchParams from "./SearchParams";
import {
	isPagePLB,
	generateCustomANDQuery,
	getLimitNumberOfProduct,
	getPageSizes,
	getTotalResults,
	getPageSortes,
	keyExistQueries,
	decimalFormat,
	booleanFormat,
	excludePresetFilter,
} from "./utils";

klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "search-landing-product-listing-block",
	fire: function () {
		if (isPagePLB()) {
			klevu.search.landing.getScope().chains.request.build.addAfter("addProductList", {
				name: "addProductListingBlock",
				fire: function (data, scope) {
					const filters = data.localOverrides.query.productList.filters.applyFilters.filters || [];
					excludePresetFilter(filters);
					const settings = data.localOverrides.query.productList.settings || {};
					data.localOverrides.query.productList.settings = generateCustomANDQuery(settings);
				}
			});

			klevu.search.landing.getScope().chains.response.success.addBefore("checkForSuccess", {
				name: "setLimitNumberOfProduct",
				fire: function (data, scope) {
					const indexProductList = 0;
					const isDataResponse = !klevu.isEmptyObject(data.response.data);
					const limitNumberOfProduct = getLimitNumberOfProduct();
					const enableLimitNumberOfProduct = limitNumberOfProduct > 0;
					if (isDataResponse && enableLimitNumberOfProduct) {
						const metaProductResults = data.response.data.queryResults[indexProductList].meta;
						const offset = metaProductResults.offset;
						const noOfResults = metaProductResults.noOfResults;

						metaProductResults.totalResultsFound = getTotalResults(metaProductResults.totalResultsFound);

						if (offset + noOfResults >= limitNumberOfProduct) {
							const recordProductResults = data.response.data.queryResults[indexProductList].records;
							data.response.data.queryResults[indexProductList].records = recordProductResults.slice(0, limitNumberOfProduct - offset);
						}

					} else if (enableLimitNumberOfProduct) {
						const metaProductResults = data.response.current.queryResults[indexProductList].meta;
						metaProductResults.totalResultsFound = getTotalResults(metaProductResults.totalResultsFound);
					}
				}
			});
			/**
			 * Update scrollToTop
			 */
			klevu.search.landing.getScope().chains.events.keyUp
				.remove({
					name: "scrollToTop"
				})
				.add({
					name: "scrollToTop",
					fire: function (data, scope) {
						const fullPageLayoutEnabled = klevu.getSetting(scope.kScope.settings, "settings.search.fullPageLayoutEnabled", false);
						if (fullPageLayoutEnabled) {
							const $landing = document.querySelector(".klevuResultsListingBlock");
							if ($landing && $landing.classList.contains("is-initialized")) {
								$landing.scrollIntoView();
							}
						}
					}
				});
		}
		klevu.search.landing.getScope().chains.request.build.addBefore("addProductList", {
			name: "convertPlusToSpaceURL",
			fire: function (data, scope) {
				const searchParams = new SearchParams();
				searchParams.pushState();
			}
		});
	}
});

/**
 *  Helper render page product list.
 */
klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "product-list-template-helpers",
	fire: function () {
		klevu.search.landing.getScope().template.setHelper("eachPageSizes", function (callBackItem) {
			getPageSizes().forEach(callBackItem);
		});

		klevu.search.landing.getScope().template.setHelper("totalByOption", getTotalResults);

		klevu.search.landing.getScope().template.setHelper("keyExistQueries", keyExistQueries);

		klevu.search.landing.getScope().template.setHelper("eachPageSortes", function (callBackItem) {
			getPageSortes().forEach(callBackItem);
		});

		klevu.search.landing.getScope().template.setHelper("decimalFormat", decimalFormat);
		klevu.search.landing.getScope().template.setHelper("booleanFormat", booleanFormat);
	}
});



// WEBPACK FOOTER //
// ./klevu/klevu-product-listing-block.js